import { Component, ViewChild, ViewContainerRef } from '@angular/core'
import { CtrlBaseComponent } from '../ctrl-base.component';
import { CtButtonComponent } from '../ct-button/ct-button.component';

@Component({
  selector: 'ct-bar-button',
  templateUrl: './ct-bar-button.component.html',
  styleUrls: ['./ct-bar-button.component.css'],
  host: {
    '[id]': 'getId()',
    '[hidden]': 'getHidden()',
    '[class]': '"bar-button-panel " + getStyleClass()'
  }
})
export class CtBarButtonComponent extends CtrlBaseComponent {

  @ViewChild('target', { read: ViewContainerRef }) target: ViewContainerRef;

  constructor() {
    super();
  }

  ngAfterViewInit() {
    this.paintChildren(this.getMetaData(), this.target);
  }

  getButtons(): CtButtonComponent[] { return <CtButtonComponent[]> this.childElements }
}